export default {
  // 首页选择条形统计图类型
  ENTRY_BAR: [
    {
      "dictLabel": "本月",
      "dictValue": "month"
    },
    {
      "dictLabel": "今年",
      "dictValue": "year"
    }
  ],
  // 商品统计维度
  GOODS_DIMENSION: [
    {
      "dictLabel": "单品",
      "dictValue": "spuId"
    },
    {
      "dictLabel": "商品",
      "dictValue": "goodsId"
    }
  ],
  // 库存统计维度
  DIMENSION: [
    {
      "dictLabel": "仓库",
      "dictValue": "wareHouseId"
    },
    {
      "dictLabel": "商品",
      "dictValue": "goodsId"
    }
  ],
  EXPORT_WAY: [
    {
      "dictLabel": "导出全部查询结果",
      "dictValue": "1"
    },
    {
      "dictLabel": "导出全部选中数据",
      "dictValue": "2"
    }
  ]
}

// {
//   "tableHeaderList": [  // 回收站 表头列的数据
//       {
//         "label": "仓库名称",
//         "prop": "wareHouseName",
//         "align": "center",
//         "minWidth": "200px"
//       },
//       {
//           "dictType": "STATUS",
//           "dictTypeNode": "tag",
//           "label": "状态",
//           "align": "center",
//           "prop": "status",
//           "minWidth": "100px"
//       },
//       {
//           "dateFormat": "datetime",
//           "label": "创建时间",
//           "align": "center",
//           "prop": "createTime",
//           "minWidth": "200px"
//       }
//   ],
//   "idField": "wareHouseId", // id字段 用于回收站彻底删除或还原操作
//   "routerName": "systemDictManage", // 用户清除该页面的缓存
//   "searchList": [ // 搜索表单的数据
//       {
//           "type": "input",
//           "label": "仓库名称",
//           "prop": "wareHouseName",
//           "placeholder": "请输入仓库名称",
//           "clearable": true
//       },
//       {
//           "type": "select",
//           "label": "状态",
//           "prop": "status",
//           "dictType": "STATUS",
//           "placeholder": "请选择状态",
//           "clearable": true
//       }
//   ]
// }